import { Amplify } from 'aws-amplify';

export async function fetchCognitoUserInfo(accessToken) {
  if (!accessToken) return null;

  const domain = Amplify.getConfig()?.Auth?.Cognito?.loginWith?.oauth?.domain;
  if (!domain) return null;

  const url = `https://${domain}/oauth2/userInfo`;
  const res = await fetch(url, {
    method: 'GET',
    headers: {
      Authorization: `Bearer ${accessToken}`,
    },
  });

  if (!res.ok) {
    const txt = await res.text().catch(() => '');
    throw new Error(`userInfo ${res.status}: ${txt || res.statusText || 'request failed'}`);
  }

  return await res.json();
}

export function pickNameFromUserInfo(userInfo) {
  if (!userInfo || typeof userInfo !== 'object') return null;
  return (
    userInfo.name ||
    userInfo.nickname ||
    userInfo.preferred_username ||
    userInfo.profile_nickname ||
    null
  );
}


